import {
  FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS,
  DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT,
  CONCAT_TEXT_LIMIT,
  DIFERENCE_MINUTES,
  HEADER_TAB_SETUP,
} from "../../functions/funtion";
import {
  ENCRYPT_STORAGE_SESSION,
  ENCRYPT_STORAGE,
  WebWidth,
  WebLeft,
  CSP,
} from "../../config/config";
import {
  GET_SET_STORED_DATA,
  GET_CART,
} from "../../database/get-stored-data";
import { PT_PRODUCT, PT_HOME } from "../../routes/stack/paths/pt-home";
import {
  dto_selected_final_merchant_or_product,
  dto_selected_merchant_or_product,
} from "../../classes/dto-selected-merchant-or-product";
import {
  Api_DrawAnalyticalPath,
  api_DaitonnAnalytical,
} from "../../connection/api/api-Machine-Learning";
import { api_LoadProductListToMobileAppForAnMID } from "../../connection/api/api-product-list";
import { api_CategoryPageLoadGroceryCategory } from "../../connection/api/api-grocery-category";
import { STORE_PRODUCT_LIST, ENTRY_MODE } from "../../database/store-names";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { SET_STORE_DINE_TYPE } from "../../database/store-data";
import { dto_common } from "../../classes/dto-common";
import { dto_Merchant } from "../../classes/dto-merchant";
import { F_Fammily } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import { Colors } from "../../util/colors";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import QuickCartButton from "./components/quick-cart-button/quick-cart-button";
import SummaryCart from "../../components/render-drawer-summary-cart/render-drawer-summary-cart";
import PlaceHolder from "./components/product-list-place-holder/product-list-place-holder";
import Category from "./components/product-lisit-category/product_list_category";
import ItemView from "./components/product-list-item/product-list-item";
import React from "react";
import "../../styles/css/pg-product-list.css";
import "../../styles/css/fixedbutton.css";
import "../../styles/css/animate.css";
var $ = require("jquery");
const cloneDeep = require("lodash.clonedeep");
const TABLE_NO = "TABLE_NO";
const qrProductListMemoryCache = new Map();

const getQrTableNumber = (entryMode, tableNo) => {
  const normalizedEntryMode = String(entryMode || "")
    .trim()
    .toUpperCase();
  const normalizedTableNo = String(tableNo || "").trim();

  if (normalizedEntryMode !== "QR") {
    return "";
  }

  if (normalizedTableNo === "" || normalizedTableNo === "0") {
    return "";
  }

  return normalizedTableNo;
};

const isDtQrEntryMode = () =>
  CSP === "DT" && ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR";

export default class QRList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CateList: [],
      PrdList: [],
      inMemoryProducts: [],
      isLoading: true,
      displayMessage: false,
      desc: "",
      DrawerIsOpen: false,
      PID: 0,
      LineID: 0,
      AddonLineID: 0,
      Category: 0,
      FromPage: 0,
      LocalCart: [],
      IsSummaryCart: false,
      ActiveIndex: 0,
      PaddingLeft: "14%",
      DelPaddingLeft: "17%",
      MainTopMargin: "0px",
      iconDisplay: "block",
      deliveryDisabled: false,
      takeawayDisabled: false,
      MerchantData: [],
      filterText: "",
      CategoryList: [],
      activeCategoryId: null,
      selectedCategoryLabel: "Category",
      loadError: "",
    };
    this.safariTouchFixTimer = null;
    this.keepCheckInterval = null;
    this.lastCartSignature = "";
    this.latestMerchantData = null;
  }

  getCartSignature = (cart = []) =>
    cart
      .map(
        (item) =>
          `${item.PID}:${item.LineID}:${item.ADDONLINEID}:${item.Qty}:${item.UP}`,
      )
      .join("|");

  refreshLocalCart = async () => {
    let cart = await GET_CART();
    if (cart === undefined) {
      cart = [];
    }

    const nextSignature = this.getCartSignature(cart);
    if (nextSignature !== this.lastCartSignature) {
      this.lastCartSignature = nextSignature;
      this.setState({ LocalCart: cart });
    }
  };

  async componentDidMount() {
    document
      .querySelectorAll(".shadow-overlay")
      .forEach((node) => node.remove());
    let HeaderCommonId = document.getElementById("DivHeaderHome");
    if (HeaderCommonId) {
      HeaderCommonId.style.display = "none";
    }
    localStorage.setItem("isAllCat", false);
    dto_selected_merchant_or_product.CATID = 0;

    await GET_SET_STORED_DATA();
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: dto_selected_merchant_or_product.Merchant,
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_HOME);
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
    await this.LoadMasterCategory();
    await this.LoadProduct();

    await api_DaitonnAnalytical();

    await this.Setdinetype();
    this.keepCheckInterval = setInterval(() => {
      this.refreshLocalCart();
    }, 750);
  }

  componentWillUnmount() {
    const element = this.handleScroll
      ? isMobile
        ? document.querySelector(".body-container")
        : document.querySelector(".WindowDevice")
      : null;
    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
      this.safariTouchFixTimer = null;
    }
    clearInterval(this.keepCheckInterval);
  }

  safariTouchFix = () => {
    const body = document.body;
    if (!body) {
      return;
    }
    body.style.pointerEvents = "auto";
    if (this.safariTouchFixTimer) {
      clearTimeout(this.safariTouchFixTimer);
    }
    requestAnimationFrame(() => {
      body.style.pointerEvents = "auto";
    });
    this.safariTouchFixTimer = setTimeout(() => {
      body.style.pointerEvents = "auto";
      this.safariTouchFixTimer = null;
    }, 400);
  };

  getScrollContainer = () => {
    if (isMobile) {
      return (
        document.querySelector(".body-container") ||
        document.scrollingElement ||
        document.documentElement ||
        document.body
      );
    }

    return (
      document.querySelector(".WindowDevice") ||
      document.scrollingElement ||
      document.documentElement ||
      document.body
    );
  };

  focusSearchInput = () => {
    setTimeout(() => {
      const input = document.getElementById("InputproductlistFilterTextBox");
      if (input) {
        input.focus();
      }
    }, 50);
  };

  getQrProductCacheKey = () => {
    const qrTableNo = getQrTableNumber(
      CSP === "DT" ? ENCRYPT_STORAGE.getItem(ENTRY_MODE) : "",
      ENCRYPT_STORAGE.getItem(TABLE_NO),
    );

    if (CSP !== "DT" || qrTableNo === "") {
      return "";
    }

    return [
      String(dto_selected_merchant_or_product.MID || ""),
      String(qrTableNo),
    ].join("::");
  };

  getCachedQrProductList = () => {
    const cacheKey = this.getQrProductCacheKey();
    if (cacheKey === "") {
      return null;
    }

    return qrProductListMemoryCache.get(cacheKey) || null;
  };

  setCachedQrProductList = (cacheValue) => {
    const cacheKey = this.getQrProductCacheKey();
    if (cacheKey === "") {
      return;
    }

    qrProductListMemoryCache.set(cacheKey, cacheValue);
  };

  getStoredProductListCache = () => {
    const cachedQrData = this.getCachedQrProductList();
    if (cachedQrData) {
      return cachedQrData;
    }

    return ENCRYPT_STORAGE.getItem(STORE_PRODUCT_LIST);
  };

  getReusableProductListCache = (
    dataStorage = this.getStoredProductListCache(),
  ) => {
    if (!dataStorage || dataStorage === "") {
      return null;
    }

    if (dataStorage.MID !== dto_selected_merchant_or_product.MID) {
      return null;
    }

    const cachedQrData = this.getCachedQrProductList();
    if (cachedQrData) {
      return cachedQrData;
    }

    const storageDateTime = new Date(dataStorage.date);
    const currentDateTime = new Date();
    const differenceMinute = DIFERENCE_MINUTES(
      currentDateTime,
      storageDateTime,
    );

    if (differenceMinute > 1) {
      return null;
    }

    if (
      !isDtQrEntryMode() &&
      dataStorage.CATID !== dto_selected_merchant_or_product.CATID
    ) {
      return null;
    }

    return dataStorage;
  };

  buildCategoryListFromProducts = (products = []) => {
    const seenKeys = new Set();

    return (Array.isArray(products) ? products : []).reduce((list, item) => {
      const catId = item?.CATID;
      const categoryName = item?.Category;
      const dedupeKey = `${String(catId || "")}::${String(
        categoryName || "",
      ).trim()}`;

      if (seenKeys.has(dedupeKey)) {
        return list;
      }

      seenKeys.add(dedupeKey);
      list.push({
        CATID: catId,
        Category: categoryName,
        ListType: item?.ListType ?? 0,
      });
      return list;
    }, []);
  };

  getFirstScrollableCategoryId = (categoryList = this.state.CategoryList) => {
    const firstCategory = (
      Array.isArray(categoryList) ? categoryList : []
    ).find((item) => Number(item?.CATID) !== 0);

    return firstCategory?.CATID ?? 0;
  };

  hasValidMerchantData = (merchantData) => {
    if (!merchantData || typeof merchantData !== "object") {
      return false;
    }

    const merchantId = String(merchantData.MID ?? "").trim();
    return (
      merchantId !== "" && merchantId !== "undefined" && merchantId !== "null"
    );
  };

  resolveMerchantData = (...merchantCandidates) => {
    const candidates = [
      ...merchantCandidates,
      this.latestMerchantData,
      this.state.MerchantData,
      dto_selected_final_merchant_or_product,
      dto_selected_merchant_or_product,
      dto_Merchant,
    ];

    return (
      candidates.find((candidate) => this.hasValidMerchantData(candidate)) ||
      null
    );
  };

  hydrateProductListFromCache = (cachedData) => {
    if (!cachedData) {
      return false;
    }

    const products = cachedData.ProductList;
    const merchantData = this.resolveMerchantData(cachedData.MerchantData);
    if (!Array.isArray(products) || !this.hasValidMerchantData(merchantData)) {
      return false;
    }

    this.setState({
      CateList: products,
      PrdList: products,
      inMemoryProducts: products,
      MerchantData: merchantData,
      CategoryList: this.buildCategoryListFromProducts(products),
      isLoading: false,
      desc: "",
    });
    return true;
  };

  setSelectedCategoryLabel = (categoryName = "") => {
    const nextLabel =
      categoryName.length > 25
        ? categoryName.slice(0, 25) + "..."
        : categoryName;
    this.setState({
      selectedCategoryLabel: nextLabel || "Category",
    });
    const selectedCat = document.getElementById("SelectedCat");
    if (!selectedCat) {
      return;
    }
    selectedCat.innerText = nextLabel;
  };

  syncHorizontalCategory = (categoryId) => {
    const hContainer = document.getElementById("horizontalCateSection");
    if (!hContainer || categoryId === undefined || categoryId === null) {
      return;
    }

    const activeBtn = hContainer.querySelector(
      `[data-catid="${String(categoryId)}"]`,
    );

    if (!activeBtn) {
      return;
    }

    const left =
      activeBtn.offsetLeft -
      hContainer.clientWidth / 2 +
      activeBtn.clientWidth / 2;

    hContainer.scrollTo({
      left: Math.max(0, left),
      behavior: "smooth",
    });
  };

  syncActiveCategory = (categoryId, categoryName = "") => {
    if (categoryName) {
      this.setSelectedCategoryLabel(categoryName);
    }

    const nextCategoryId = String(categoryId);
    if (this.state.activeCategoryId !== nextCategoryId) {
      this.setState({ activeCategoryId: nextCategoryId }, () => {
        this.syncHorizontalCategory(nextCategoryId);
      });
      return;
    }

    this.syncHorizontalCategory(nextCategoryId);
  };

  handleCategoryClick = (cate) => {
    const firstCATID = this.getFirstScrollableCategoryId();
    const targetCATID = Number(cate?.CATID) === 0 ? firstCATID : cate?.CATID;
    const categoryName = String(cate?.Category || "");

    dto_selected_merchant_or_product.CATID = targetCATID;
    dto_MobileAppCategory.ListType = cate?.ListType ?? 0;

    this.syncActiveCategory(targetCATID, categoryName);

    requestAnimationFrame(() => {
      this.scrollToTarget(targetCATID + "SECTIONS", 150);
      this.safariTouchFix();
    });
  };

  scrollToTarget = (targetId, offset = 105) => {
    const target = document.getElementById(targetId);
    if (!target) {
      return;
    }

    const container = this.getScrollContainer();
    if (!container) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const isDocumentContainer =
      container === document.body ||
      container === document.documentElement ||
      container === document.scrollingElement;

    if (isDocumentContainer) {
      window.scrollTo({
        top: Math.max(0, target.offsetTop - offset),
        behavior: "smooth",
      });
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const nextTop =
      container.scrollTop + (targetRect.top - containerRect.top) - offset;

    container.scrollTo({
      top: Math.max(0, nextTop),
      behavior: "smooth",
    });
  };

  getTotalPrice() {
    const total = this.state.LocalCart.reduce(
      (sum, item) => sum + item.Qty * item.UP,
      0,
    );
    const formattedTotal = total.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${dto_StartupPageLoadInfo.Currency} ${formattedTotal}`;
  }

  render() {
    const from = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const hideDineTypeForQr = CSP === "DT" && from === "QR";
    const qrTableNo = getQrTableNumber(
      CSP === "DT" ? from : "",
      ENCRYPT_STORAGE.getItem(TABLE_NO),
    );

    if (this.state.loadError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            height: "70vh",
            padding: "0 20px",
          }}
        >
          <i
            className="bi bi-exclamation-triangle"
            style={{ fontSize: 48, color: Colors.ThemeBGcolor || "#c0392b" }}
          />
          <p style={{ fontFamily: F_Fammily.Medium, marginTop: 15 }}>
            {this.state.loadError}
          </p>
          <button
            style={{
              fontFamily: F_Fammily.Medium,
              backgroundColor: Colors.DarkGreyScale,
              color: "#fff",
              border: "none",
              borderRadius: 4,
              padding: "10px 24px",
              marginTop: 10,
              cursor: "pointer",
            }}
            onClick={() => this.props.navigate(PT_HOME)}
          >
            Go to Home
          </button>
        </div>
      );
    }

    return (
      <div
        id="OnScrollProdcutList"
        style={{
          marginBottom: 55,
          WebkitTextSizeAdjust: "100%",
          textSizeAdjust: "100%",
          marginTop: this.state.MainTopMargin,
        }}
      >
        <div
          id="NewFilterationTextBox"
          className="fadeInBottom cssanimation"
          style={{
            display: "none",
            position: "absolute",
            paddingTop: "5px",
            top: 0,
            height: 50,
            width: "100%",
            zIndex: 1800,
            backgroundColor: "white",
          }}
        >
          <div style={{ display: "flex" }}>
            {/* textbox */}
            <input
              className="productlistFilterTextBox"
              type="text"
              style={{
                width: "90%",
                height: 50,
                border: "none",
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                paddingLeft: "8px",
              }}
              value={this.state.filterText}
              placeholder="Fillter Items"
              id="InputproductlistFilterTextBox"
              onChange={this.handleFilterChange}
            />

            {/* circle close */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderRight: "1px solid gray",
                color: "#a1a1a1",
                backgroundColor: "#fff",
                padding: "7px",
              }}
              id="btnproductlistFilterTextBoxclear"
              onClick={this.resetFilter}
            >
              <i className="bi bi-x-circle-fill" />
            </button>

            {/* cancel */}
            <button
              className="productlistFilterTextBox"
              style={{
                height: 50,
                border: "none",
                cursor: "pointer",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                backgroundColor: "white",
                fontFamily: F_Fammily.Medium,
                fontWeight: "600",
              }}
              id="btnproductlistFilterTextBoxClsoe"
              onClick={this.handleCancelClick}
            >
              Cancel
            </button>
          </div>
        </div>

        {this.state.isLoading ? (
          <PlaceHolder />
        ) : (
          <>
            <div
              style={{
                display: "block",
              }}
            >
              {/* Parent div with relative positioning */}
              <div style={{ position: "relative" }}>
                <img
                  src={this.state.MerchantData.IL}
                  style={{ width: "100%", height: 180, objectFit: "cover" }}
                  alt={this.state.MerchantData.IL}
                />

                {/* Search Icon */}
                <div
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    top: "10px",
                    right: "5px",
                    fontSize: 24,
                    color: "white",
                    padding: "5px",
                    borderRadius: "30px",
                    display: this.state.iconDisplay,
                  }}
                  id="HeaderNavigatorBoostrapIcon"
                  onClick={() => {
                    const el = document.getElementById("NewFilterationTextBox");
                    if (el) {
                      el.classList.add("active");
                      $("#NewFilterationTextBox").fadeIn(500);
                      this.focusSearchInput();
                    }
                  }}
                >
                  <i className="bi bi-search" />
                </div>
              </div>

              {/* Merchant Info Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 5px",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-shop" style={{ paddingRight: "8px" }} />
                  {this.state.MerchantData.Merchant}
                </div>

                <div
                  style={{
                    display: "none",
                    alignItems: "center",
                  }}
                >
                  <i className="bi bi-hand-thumbs-up-fill" />
                  <span style={{ fontSize: "12px", marginLeft: "5px" }}>
                    {" "}
                    {this.state.MerchantData.AR}%
                  </span>
                </div>

                <div
                  style={{
                    display:
                      CSP === "DT" &&
                      this.state.MerchantData.MS !== "OPEN" &&
                      from === "QR"
                        ? "flex"
                        : "none",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      marginLeft: "5px",
                      fontWeight: "bold",
                      color: "red",
                    }}
                  >
                    {this.state.MerchantData.MS}
                  </span>
                </div>
              </div>

              <div
                className="commonnWrap"
                style={{
                  marginLeft: "2%",
                  display: "flex",
                  paddingLeft: 0,
                }}
              >
                {/* switch Bed */}
                {hideDineTypeForQr ? (
                  <div
                    className="DTSwitchBox"
                    style={{
                      marginLeft: 0,
                      marginRight: 0,
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                          qrTableNo !== "" ? "space-between" : "center",
                        paddingBottom: "3%",
                        paddingTop: "3%",
                        paddingLeft: qrTableNo !== "" ? "18px" : 0,
                        paddingRight: qrTableNo !== "" ? "18px" : 0,
                        backgroundColor: "white",
                        borderRadius: "20px",
                        color: "black",
                        fontWeight: "bolder",
                        fontSize: "18px",
                      }}
                    >
                      <span>{qrTableNo !== "" ? "DINE-IN" : "PICK UP"}</span>
                      {qrTableNo !== "" ? (
                        <span>{`Table ${qrTableNo}`}</span>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  <div
                    className="DTSwitchBox"
                    style={{
                      marginLeft: "4%",
                      width: "90%",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: "50%",
                        textAlign: "center",
                        paddingBottom: "3%",
                        paddingTop: "3%",
                        cursor: this.state.deliveryDisabled
                          ? "not-allowed"
                          : "pointer",
                        backgroundColor:
                          this.state.ActiveIndex === 0
                            ? "white"
                            : "rgb(196, 192, 192)",
                        borderRadius: "20px",
                        color: this.state.deliveryDisabled ? "grey" : "black",
                        opacity: this.state.deliveryDisabled ? 0.5 : 1,
                        fontWeight:
                          this.state.ActiveIndex === 0 ? "bolder" : "normal",
                        fontSize:
                          this.state.ActiveIndex === 0 ? "18px" : "15px",
                      }}
                      onClick={() => {
                        if (!this.state.deliveryDisabled) {
                          this.setState({ ActiveIndex: 0 });
                          if (
                            dto_selected_merchant_or_product.MID ===
                            dto_selected_final_merchant_or_product.MID
                          ) {
                            SET_STORE_DINE_TYPE(4);
                          }
                        }
                      }}
                    >
                      DELIVERY
                    </div>
                    <div
                      style={{
                        fontFamily: F_Fammily.Medium,
                        width: "50%",
                        textAlign: "center",
                        cursor: this.state.takeawayDisabled
                          ? "not-allowed"
                          : "pointer",
                        paddingBottom: "3%",
                        paddingTop: "3%",
                        backgroundColor:
                          this.state.ActiveIndex === 1
                            ? "white"
                            : "rgb(196, 192, 192)",
                        borderRadius: "20px",
                        color: this.state.takeawayDisabled ? "grey" : "black",
                        opacity: this.state.takeawayDisabled ? 0.5 : 1,
                        fontWeight:
                          this.state.ActiveIndex === 1 ? "bolder" : "normal",
                        fontSize:
                          this.state.ActiveIndex === 1 ? "18px" : "15px",
                      }}
                      onClick={() => {
                        if (!this.state.takeawayDisabled) {
                          this.setState({ ActiveIndex: 1 });
                          if (
                            dto_selected_merchant_or_product.MID ===
                            dto_selected_final_merchant_or_product.MID
                          ) {
                            SET_STORE_DINE_TYPE(3);
                          }
                        }
                      }}
                    >
                      PICK UP
                    </div>
                  </div>
                )}
              </div>
            </div>

            {this.state.CateList.length !== 0 ? (
              <div>
                <div
                  style={{
                    backgroundColor: "white",
                    position: "fixed",
                    left: isMobile ? 0 : WebLeft,
                    width: isMobile ? "100%" : WebWidth,
                    right: 0,
                    zIndex: 1500,
                    overflowY: "hidden",
                    padding: "10px 12px 8px 12px",
                    top: 0,
                    display: "block",
                    boxShadow: "0 2px 6px 0 rgba(0,0,0,0.12)",
                  }}
                  id="cateSection"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "2px 4px 10px 4px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 18,
                        fontFamily: F_Fammily.Medium,
                        fontWeight: "bold",
                        color: "black",
                        textTransform: "uppercase",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        paddingRight: 12,
                      }}
                    >
                      {this.state.MerchantData.Merchant}
                    </div>
                    <div
                      style={{
                        fontSize: 24,
                        color: "black",
                        padding: "2px 4px",
                        cursor: "pointer",
                        flex: "0 0 auto",
                      }}
                      onClick={() => {
                        const el = document.getElementById(
                          "NewFilterationTextBox",
                        );
                        if (el) {
                          el.classList.add("active");
                          $("#NewFilterationTextBox").fadeIn(500);
                          this.focusSearchInput();
                        }
                      }}
                    >
                      <i className="bi bi-search" />
                    </div>
                  </div>

                  <div
                    id="horizontalCateSection"
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      paddingBottom: "10px",
                    }}
                  >
                    {this.state.CategoryList.map((cate, i) => {
                      const isActiveCategory =
                        String(this.state.activeCategoryId) ===
                        String(cate.CATID);
                      return (
                        <div
                          data-catid={cate.CATID}
                          key={"dropdownKey" + i + cate.CATID}
                          style={{
                            backgroundColor: isActiveCategory
                              ? Colors.DarkGreyScale
                              : Colors.LightGreyScale,
                            color: isActiveCategory
                              ? "white"
                              : Colors.DarkGreyScale,
                            border: "1px solid #474747",
                            fontWeight: "bold",
                            fontSize: "14px",
                            padding: "8px 16px",
                            whiteSpace: "normal",
                            flex: "0 0 auto",
                            marginRight: "10px",
                            borderRadius: "10px",
                            textAlign: "center",
                          }}
                          onClick={() => this.handleCategoryClick(cate)}
                        >
                          {cate.Category.toUpperCase()}
                        </div>
                      );
                    })}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderTop: "1px solid #ececec",
                      padding: "10px 4px 2px 4px",
                    }}
                  >
                    <h1
                      id="SelectedCat"
                      style={{
                        fontSize: 21,
                        fontFamily: F_Fammily.Medium,
                        margin: 0,
                        fontWeight: "bold",
                        color: "black",
                        textAlign: "left",
                        textTransform: "uppercase",
                      }}
                    >
                      {this.state.selectedCategoryLabel}
                    </h1>
                  </div>
                </div>

                <div
                  className="container"
                  style={{
                    marginLeft: 10,
                    marginRight: 10,
                    marginTop: 0,
                  }}
                >
                  <div>
                    {this.state.PrdList.map &&
                      this.state.PrdList.map((cate, i) => {
                        let PrdList = [];
                        PrdList = JSON.parse(cate.dtoProductSessionList);
                        if (PrdList.length > 0) {
                          return (
                            <div
                              className="ItemList"
                              id={cate.CATID + "SECTIONS"}
                              key={cate.CATID + "ProductList" + i + "Key"}
                            >
                              <div
                                className="row"
                                key={cate.CATID + i + "Key"}
                                style={{ display: "block" }}
                              >
                                <Category
                                  Category={cate.Category.toUpperCase()}
                                  ID={cate.CATID}
                                  key={
                                    cate.CATID + "CategoryHeading" + i + "Key"
                                  }
                                />
                              </div>
                              <div className="" key={i + cate.CATID + "PRD"}>
                                {PrdList.map((item, i) => {
                                  return (
                                    <>
                                      <ItemView
                                        onClick={async (rs, index) => {
                                          await Api_DrawAnalyticalPath(1, rs);
                                          ENCRYPT_STORAGE_SESSION.setItem(
                                            "PrdIdScroll",
                                            rs + "PRD" + index,
                                          );

                                          this.props.navigate(
                                            PT_PRODUCT.replace(
                                              ":frompage",
                                              "product-list",
                                            )
                                              .replace(
                                                ":navigatepage",
                                                "product-list",
                                              )
                                              .replace(
                                                ":category",
                                                cate.Category.replace(
                                                  "/",
                                                  "-",
                                                ).toLowerCase(),
                                              )
                                              .replace(":pid", rs)
                                              .replace(":lineid", 1)
                                              .replace(":adonlineid", 1)
                                              .replace(":isrecommended", 0),
                                          );
                                          this.safariTouchFix();
                                        }}
                                        key={item.PI + "ProductList" + i}
                                        pid={item.PI}
                                        data={item}
                                        index={i}
                                        Description={item.D}
                                        GenDesc={item.G}
                                        SP={item.P}
                                        UD={item.UD}
                                        IsAvailable={item.A}
                                        ProductImage={
                                          <div className="">
                                            {item.IU !== "" &&
                                            item.IU !== "N/A" ? (
                                              <img
                                                style={{
                                                  height: 70,
                                                  width: 70,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                }}
                                                loading="lazy"
                                                id={"prdImageLise" + item.PI}
                                                src={item.IU.split("λ")[0]}
                                                alt=""
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                              />
                                            ) : (
                                              <img
                                                style={{
                                                  height: 30,
                                                  width: 30,
                                                  padding: 0,
                                                  borderRadius: 10,
                                                  filter: "grayscale(100%)",
                                                  WebkitFilter:
                                                    "grayscale(100%)",
                                                }}
                                                src={dto_common.DefaultImageUrl}
                                                onError={(e) => {
                                                  e.currentTarget.src =
                                                    dto_common.DefaultImageUrl;
                                                }}
                                                alt=""
                                              />
                                            )}
                                          </div>
                                        }
                                      />
                                      <div
                                        style={{
                                          borderTop: "1px solid black",
                                          transform: "scaleY(0.1)",
                                          display: "block",
                                        }}
                                      />
                                    </>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                  </div>

                  {this.state.displayMessage ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: "70px",
                        height: "100vh",
                      }}
                    >
                      <img
                        src={require("./images/NoDataFound.jpg")}
                        width={"60%"}
                        alt=""
                      />

                      <label
                        style={{
                          fontWeight: "bold",
                          marginBottom: "8px",
                          textAlign: "center",
                        }}
                      >
                        We did not find a match
                      </label>
                      <label style={{ textAlign: "center" }}>
                        Try searching for something instead
                      </label>
                    </div>
                  ) : null}
                </div>

                {!this.state.displayMessage ? (
                  <button
                    id="ScrollToTopBTN"
                    title="Go to top"
                    style={{ left: isMobile ? "80%" : "63%" }}
                    onClick={() => {
                      if (isMobile) {
                        window.scrollTo({ top: 10, behavior: "smooth" });
                      } else {
                        const el = document.querySelector(".WindowDevice");
                        el && el.scrollTo({ top: 10, behavior: "smooth" });
                      }
                    }}
                  >
                    <i
                      className="bi bi-arrow-up-square"
                      style={{ fontSize: 28 }}
                    />
                  </button>
                ) : null}

                {this.state.LocalCart.length > 0 ? (
                  <QuickCartButton
                    totalPrice={this.getTotalPrice()}
                    itemCount={this.state.LocalCart.length}
                    onClick={async () => {
                      let Localcart = await GET_CART();
                      if (Localcart === undefined) {
                        Localcart = [];
                      }
                      this.setState(
                        { IsSummaryCart: true, LocalCart: Localcart },
                        async () => {
                          await DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(
                            async () => {
                              let Localcart = await GET_CART();
                              if (Localcart === undefined) {
                                Localcart = [];
                              }
                              this.setState({
                                IsSummaryCart: false,
                                LocalCart: Localcart,
                              });
                            },
                          );
                        },
                      );
                    }}
                  />
                ) : null}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "70px",
                  height: "100vh",
                }}
              >
                <img
                  src={require("./images/NoDataFound.jpg")}
                  width={"60%"}
                  alt=""
                />

                <label
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                    textAlign: "center",
                  }}
                >
                  We did not find a match
                </label>
                <label style={{ textAlign: "center" }}>
                  Try searching for something instead
                </label>
              </div>
            )}
          </>
        )}

        <DrawerSheetBottom
          open={this.state.IsSummaryCart}
          closeFunction={() =>
            this.setState({ IsSummaryCart: false }, () => {
              this.safariTouchFix();
            })
          }
          element={
            <SummaryCart
              CartData={this.state.LocalCart}
              navigate={this.props.navigate}
              ItemClick={async (item) => {
                this.setState({ IsSummaryCart: false }, () => {
                  this.props.navigate(
                    PT_PRODUCT.replace(":frompage", "cart")
                      .replace(":navigatepage", "product-list")
                      .replace(":category", "category")
                      .replace(":pid", item.PID)
                      .replace(":lineid", item.LineID)
                      .replace(":adonlineid", item.ADDONLINEID)
                      .replace(":isrecommended", 0),
                  );
                });
              }}
              onCartUpdated={(updatedCart) => {
                this.setState({
                  LocalCart: updatedCart,
                  IsSummaryCart: updatedCart.length > 0,
                });
              }}
              closeFunction={() =>
                this.setState({ IsSummaryCart: false }, () => {
                  this.safariTouchFix();
                })
              }
            />
          }
          size={isMobile ? "85%" : 280}
          Heading="Shopping List"
        />
      </div>
    );
  }

  async Setdinetype() {
    SET_STORE_DINE_TYPE(3);
    this.setState({
      ActiveIndex: 1,
      deliveryDisabled: true,
      takeawayDisabled: false,
    });
  }

  async TransformationFillterTextBox() {
    var element = document.getElementsByClassName("transform");
    element[0].classList.add("transform-active-fillter-product");
    $(".productlistFilterTextBox").fadeIn(1000);
    this.focusSearchInput();

    FILTER_PRODUCTLIST_TEXT_BOX_AND_BUTTONS({
      FnFilterTextBox: (e) => {
        this.InputproductlistFilterTextBoxOnChange(e);
      },
      FnFilterCloseButton: (e) => {
        if (element) {
          element[0].classList.remove("transform-active-fillter-product");
          $(".productlistFilterTextBox").fadeOut(800);
          const el = document.getElementById("NewFilterationTextBox");
          if (el) {
            el.classList.remove("active");
            $("#NewFilterationTextBox").fadeOut(800);
          }

          this.setState({
            PrdList: this.state.inMemoryProducts,
            CateList: this.state.inMemoryProducts,
            displayMessage: false,
          });
        }
      },
      FnFilterClearButton: (e) => {
        this.setState((state) => {
          const PrdList = [...this.state.inMemoryProducts];
          const CateList = [...this.state.inMemoryProducts];
          const displayMessage = false;
          return {
            PrdList,
            CateList,
            displayMessage,
          };
        });
      },
    });
  }

  async LoadMasterCategory() {
    let data = await api_CategoryPageLoadGroceryCategory();
    let objData = JSON.parse(data);
    this.setState({ CategoryList: objData });
  }

  async LoadApiProduct() {
    let data = await api_LoadProductListToMobileAppForAnMID();
    let ObjData = JSON.parse(data);
    let ProductList = ObjData[0];
    let MerchantDataa = this.resolveMerchantData(ObjData[1]);
    if (!this.hasValidMerchantData(MerchantDataa)) {
      MerchantDataa = this.resolveMerchantData();
    }
    this.latestMerchantData = MerchantDataa;
    this.setState({ MerchantData: MerchantDataa });
    ENCRYPT_STORAGE.removeItem(STORE_PRODUCT_LIST);
    ENCRYPT_STORAGE.setItem(STORE_PRODUCT_LIST, {
      ProductList,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      date: new Date(),
      CATID: dto_selected_merchant_or_product.CATID,
    });
    this.setCachedQrProductList({
      ProductList,
      MID: MerchantDataa.MID,
      MerchantData: MerchantDataa,
      CATID: dto_selected_merchant_or_product.CATID,
    });
    return ProductList;
  }

  async LoadProduct() {
    try {
      let dataStorage = this.getStoredProductListCache();
      const reusableCache = this.getReusableProductListCache(dataStorage);
      const hydratedFromCache = this.hydrateProductListFromCache(reusableCache);
      this.setState({
        isLoading: !hydratedFromCache,
        desc: "",
      });
      let data = "";
      let merchantData = null;
      if (dataStorage !== undefined && dataStorage !== "") {
        if (dataStorage.MID === dto_selected_merchant_or_product.MID) {
          const cachedQrData = this.getCachedQrProductList();
          if (cachedQrData) {
            data = cachedQrData.ProductList;
            merchantData = this.resolveMerchantData(cachedQrData.MerchantData);
            this.latestMerchantData = merchantData;
            this.setState({ MerchantData: merchantData });
          } else {
            let StorageDateTime = new Date(dataStorage.date);
            let currentDateTime = new Date();
            let DifferenceMinute = DIFERENCE_MINUTES(
              currentDateTime,
              StorageDateTime,
            );
            if (DifferenceMinute > 1) {
              ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
              data = await this.LoadApiProduct();
              merchantData = this.resolveMerchantData(this.state.MerchantData);
            } else {
              if (
                isDtQrEntryMode() ||
                dataStorage.CATID === dto_selected_merchant_or_product.CATID
              ) {
                data = dataStorage.ProductList;
                merchantData = this.resolveMerchantData(
                  dataStorage.MerchantData,
                );
                this.latestMerchantData = merchantData;
                this.setState({ MerchantData: merchantData });
              } else {
                ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
                data = await this.LoadApiProduct();
                merchantData = this.resolveMerchantData(
                  this.state.MerchantData,
                );
              }
            }
          }
        } else {
          ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
          data = await this.LoadApiProduct();
          merchantData = this.resolveMerchantData(this.state.MerchantData);
        }
      } else {
        ENCRYPT_STORAGE_SESSION.removeItem("PrdIdScroll");
        data = await this.LoadApiProduct();
        merchantData = this.resolveMerchantData(this.state.MerchantData);
      }

      merchantData = this.resolveMerchantData(merchantData);
      this.latestMerchantData = merchantData;
      let Localcart = await GET_CART();
      if (Localcart === undefined) {
        Localcart = [];
      }

      const productCategoryList = this.buildCategoryListFromProducts(data);
      const fallbackCategoryList =
        productCategoryList.length > 0
          ? productCategoryList
          : this.state.CategoryList;
      const initialCategoryId =
        Number(dto_selected_merchant_or_product.CATID) === 0
          ? this.getFirstScrollableCategoryId(fallbackCategoryList)
          : dto_selected_merchant_or_product.CATID;
      const initialCategory = fallbackCategoryList.find(
        (item) => String(item?.CATID) === String(initialCategoryId),
      );

      this.setState(
        {
          CateList: data,
          PrdList: data,
          inMemoryProducts: data,
          isLoading: false,
          LocalCart: Localcart,
          MerchantData: merchantData,
          CategoryList: fallbackCategoryList,
          activeCategoryId: String(initialCategoryId),
          selectedCategoryLabel:
            initialCategory?.Category?.length > 25
              ? initialCategory.Category.slice(0, 25) + "..."
              : initialCategory?.Category || "Category",
        },
        () => {},
      );

      setTimeout(async () => {
        if (!this.state.isLoading) {
          await this.ScrollIndicaterMenu();
        }
      }, 500);

      setTimeout(() => {
        let PID = ENCRYPT_STORAGE_SESSION.getItem("PrdIdScroll");
        if (PID !== undefined) {
          this.scrollToTarget(PID, 110);
        } else {
          const container = isMobile
            ? document.querySelector(".body-container")
            : document.querySelector(".WindowDevice");
          if (container && container.scrollTo) {
            container.scrollTo({ top: 10, behavior: "auto" });
          } else {
            window.scrollTo({ top: 10, behavior: "auto" });
          }
        }
      }, 100);
      setTimeout(() => {
        let cateSection = document.getElementById("cateSection");
        if (cateSection) {
          cateSection.style.display = "none";
        }
      }, 50);
    } catch (error) {
      console.error("LoadProductList : " + error);
      const message = error?.isInvalidQrMerchant
        ? "This QR code isn't linked to a valid menu. Please contact the restaurant."
        : "Something went wrong while loading the menu. Please try again.";
      this.setState({ isLoading: false, loadError: message });
    }
  }

  async ScrollIndicaterMenu() {
    let ItemSection = document.getElementsByClassName("ItemList");

    let element;
    if (isMobile) {
      element = document.querySelector(".body-container");
    } else {
      element = document.querySelector(".WindowDevice");
    }

    if (element && this.handleScroll) {
      element.removeEventListener("scroll", this.handleScroll);
    }

    this.handleScroll = async () => {
      const top = element ? element.scrollTop : 0;
      for (let i = 0; i < ItemSection.length; i++) {
        let offset = ItemSection[i].offsetTop - 160;
        let Height = ItemSection[i].offsetHeight;
        let ID = ItemSection[i].id;
        let ScrollToTopBTN = document.getElementById("ScrollToTopBTN");

        if (top > 252) {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = "block";
          }
        } else {
          const cateSection = document.getElementById("cateSection");
          if (cateSection) {
            cateSection.style.display = "none";
          }
          this.setState({
            MainTopMargin: "0px",
            iconDisplay: "block",
          });
        }

        if (top > 1630) {
          ScrollToTopBTN.style.display = "none";
        } else {
          ScrollToTopBTN.style.display = "none";
        }

        if (top >= offset && top < offset + Height) {
          let x = document.getElementById(ID);
          let CategoryName = x.querySelector("h1").innerText;
          const currentCATID = ID.replace("SECTIONS", "");
          this.syncActiveCategory(currentCATID, CategoryName);
          setTimeout(() => {
            this.safariTouchFix();
          }, 0);
        }
      }
    };
    if (element) {
      element.addEventListener("scroll", this.handleScroll);
    }
    this.handleScroll();
  }

  handleFilterChange = (e) => {
    const filterText = e.target.value;
    this.setState({ filterText });
    this.filterProductList(filterText.toLowerCase());
  };

  filterProductList = (filterText) => {
    const filteredCateList = this.state.inMemoryProducts
      .map((category) => {
        const filteredProducts = JSON.parse(
          category.dtoProductSessionList,
        ).filter((product) => product.D.toLowerCase().includes(filterText));
        return {
          ...category,
          dtoProductSessionList: JSON.stringify(filteredProducts),
        };
      })
      .filter(
        (category) => JSON.parse(category.dtoProductSessionList).length > 0,
      );

    this.setState({
      CateList: filteredCateList,
      PrdList: filteredCateList,
      displayMessage: filteredCateList.length === 0,
    });
  };

  resetFilter = () => {
    this.setState({
      CateList: this.state.inMemoryProducts,
      PrdList: this.state.inMemoryProducts,
      displayMessage: false,
      filterText: "",
    });
  };

  handleCancelClick = () => {
    $("#NewFilterationTextBox").animate(
      {
        height: "toggle",
      },
      500,
      () => {
        const el = document.getElementById("NewFilterationTextBox");
        if (el) {
          el.classList.remove("active");
        }
        this.resetFilter();
        const overlay = document.querySelector(".shadow-overlay");
        if (overlay) {
          overlay.style.display = "none";
        }
        $("#NewFilterationTextBox").hide();
      },
    );
  };

  InputproductlistFilterTextBoxOnChange(e) {
    let item = [];
    let IsFiltered = false;
    let TempItems = cloneDeep(this.state.inMemoryProducts);
    TempItems.forEach((rs) => {
      let lIstArrayPrd = [];
      let products = JSON.parse(rs.dtoProductSessionList);

      products.filter((prd) => {
        let isMatch = prd.D.toLowerCase().includes(
          e.currentTarget.value.toLowerCase(),
        );
        if (isMatch) {
          IsFiltered = true;
          lIstArrayPrd.push(prd);
        }
        return isMatch;
      });

      rs.dtoProductSessionList = JSON.stringify(lIstArrayPrd);
      item.push(rs);
    });
    if (IsFiltered) {
      this.setState({ PrdList: item, CateList: item, displayMessage: false });
    } else {
      this.setState({ PrdList: item, CateList: item, displayMessage: true });
    }
  }
}
